import type { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';
import { usePortal } from '../../hooks/usePortal';

type PortalProps = {
  createTopLevelPortal?: boolean;
} & (
  | {
      portalId: string;
      portalElement?: undefined;
    }
  | {
      portalId?: string;
      portalElement: HTMLElement;
    }
);

export const Portal = ({
  children,
  portalId,
  portalElement,
  createTopLevelPortal = false,
}: PropsWithChildren<PortalProps>) => {
  const { portalRef } = usePortal(portalId ?? '', createTopLevelPortal);

  if (portalElement) {
    return createPortal(children, portalElement, portalId);
  }
  if (portalRef) {
    return createPortal(children, portalRef, portalId);
  }
  return null;
};
